/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { MDCRipple, MDCRippleFoundation } from '@material/ripple';
export class ForgeRipple extends MDCRipple {
    /** Manually trigger focus activation. */
    handleFocus() {
        this.foundation.handleFocus();
    }
    /** Manually trigger blur activation */
    handleBlur() {
        this.foundation.handleBlur();
    }
    /** Executes the ripple animation. */
    animate() {
        this.foundation.animateActivation(); // MDC does not expose this method, using `any` to access it.
    }
}
export class ForgeRippleFoundation extends MDCRippleFoundation {
}
